// extracted by mini-css-extract-plugin
export var cartIcon = "_o8-0";
export var cartIconContainer = "_o8-1";